import { useQuery } from 'data-fetching-client';
import { useAppContext } from '../context/AppContext';
export function useAppContextQuery(args) {
  const query = useAppContext() === 'app' ? args.app : args.public;
  return useQuery(query, args.options);
}